import { CmsMeta } from '../cmsMeta';
import { useTranslation } from '../../../i18n/i18n';
import './CmsPopularCategoriesGrid.css';
import { ReactNode } from 'react';

type CmsPopularCategoriesGridProps = {
	children: ReactNode;
};

export const CmsPopularCategoriesGrid = ({ children }: CmsPopularCategoriesGridProps): JSX.Element => {
	const t = useTranslation().popularCategories;

	return (
		<div className="popular-categories">
			<h2>{t.popularCategories}</h2>
			<div className="category-scroll">{children}</div>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A grid of category shortcuts, each a CmsPopularCategoryItem. The icons are small svgs, so upload one per category rather than reusing a photo.',
	example: [
		'CmsPopularCategoriesGrid',
		{ index: 3 },
		[
			'CmsPopularCategoryItem',
			{
				index: 0,
				title: 'Papierhandtücher',
				img: 'https://cdn.ondio.com/assets/0754b58d57cf4c4580f5b376dc48ff9d.svg',
				link: '/c/reinigung-hygiene/papierhandtucher-toilettenpapier/papierhandtucher',
				width: '33',
				height: '32',
			},
		],
	],
};
